const ignored_keys = ["set", "update", "subscribe"];
export const get_parameters = function (query) {
  // You must pass a query.
  let parameters = [];
  Object.keys(query).forEach((key) => {
    if (ignored_keys.indexOf(key) === -1) {
      let value = query[key];
      if (Array.isArray(value)) {
        // Logic specific for ZPublisher.
        // portal_type=["a","b"] must be coded as:
        // portal_type:list=a and portal_type:list=b.
        key += ":list";
        value.forEach((val) => {
          parameters.push(key + "=" + val);
        });
      } else if (key === "effective") {
        // We are building this: {"query": (start, end), "range": "min:max"}
        let start = value + "-01-01";
        let end = (value + 1) + "-01-01";
        parameters.push(key + ".query=" + start);
        parameters.push(key + ".query=" + end);
        parameters.push(key + ".range=min:max");
      } else if (value !== null && value !== ""){
        parameters.push(key + "=" + (value));
      }
    }
  });
  // Sort so we can more surely compare with previous search parameters in the filters.
  parameters.sort();
  return parameters;
};
